export interface TeamMember {
  name: string;
  role: string;
  bio: string;
}

export const teamMembers: TeamMember[] = [
  {
    name: "周叙",
    role: "主编 / 内容总监",
    bio: "十年影视内容从业经验，长期负责影视资讯与深度解析的选题策划与内容把关。",
  },
  {
    name: "林照",
    role: "首席影评人",
    bio: "专注剧情结构与角色动机分析，擅长将复杂的叙事拆解成读者一眼就能读懂的脉络。",
  },
  {
    name: "苏澈",
    role: "剧集观察员",
    bio: "长期跟踪国内外剧集动态，负责电视剧频道的选题与剧集综述撰写。",
  },
  {
    name: "程屿",
    role: "责任编辑",
    bio: "负责稿件的事实核对与文字打磨，确保每一条资讯准确、详尽且易读。",
  },
];